import React from "react";
import { Tag } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const STATUS_CONFIG = {
  pending:     { color: "processing", label: "Research pending" },
  researched:  { color: "purple",     label: "Researched" },
  validated:   { color: "success",    label: "Validated" },
  delivered:   { color: "cyan",       label: "Delivered" },
  failed:      { color: "error",      label: "Research failed" },
};

/**
 * Small inline badge that indicates a conversation's research status.
 * Renders nothing when there is no research status (avoids visual noise).
 *
 * Props:
 *   researchStatus - string | null | undefined
 *   onClick        - optional click handler (defaults to navigating to /polly/research)
 */
export default function ResearchStatusBadge({ researchStatus, onClick }) {
  if (!researchStatus) return null;

  const config = STATUS_CONFIG[researchStatus];
  if (!config) return null;

  const handleClick = (e) => {
    e.stopPropagation(); // prevent parent row click from firing
    if (onClick) {
      onClick(e);
    } else {
      // Navigate to Research Queue page
      window.location.href = "/polly/research";
    }
  };

  return (
    <Tag
      color={config.color}
      icon={<SearchOutlined />}
      style={{ cursor: "pointer", fontSize: 11, marginLeft: 6 }}
      onClick={handleClick}
    >
      {config.label}
    </Tag>
  );
}
